import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface LinhVucDieuTra {
  name: string;
  api_token: string;
}

export interface LinhVucDieuTraInfor {
  errors: unknown;
  linhVucDieuTraData: LinhVucDieuTra;
  cuocDieuTraData: LinhVucDieuTra;
  isAuthenticated: boolean;
}

@Module
export default class LinhVucDieuTraModule
  extends VuexModule
  implements LinhVucDieuTraInfor
{
  errors = {};
  linhVucDieuTraData = {} as LinhVucDieuTra;
  cuocDieuTraData = {} as LinhVucDieuTra;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get getLinhVucDieuTraInfo() {
    return this.linhVucDieuTraSearchData;
  }

  get getCuocDieuTraInfo() {
    return this.cuocDieuTraSearchData;
  }
  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.LINHVUC_DIEUTRA_SEARCH_DATA](linhVucDieuTra) {
    this.linhVucDieuTraSearchData = linhVucDieuTra;
  }

  @Action
  [Actions.LINHVUC_DIEUTRA_DATA_SEARCH]() {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("gis/dmchitieu/showLinhvucdieutra")
        .then(({ data }) => {
          this.context.commit(Mutations.LINHVUC_DIEUTRA_SEARCH_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Mutation
  [Mutations.CUOCDIEUTRA_SEARCH_DATA](cuocVucDieuTra) {
    this.cuocDieuTraSearchData = cuocVucDieuTra;
  }

  @Action
  [Actions.CUOCDIEUTRA_DATA_SEARCH](data) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/gis/dmchitieu",
        "showCuocdieutra",
        data,
        {}
      )
        .then(({ data }) => {
          this.context.commit(Mutations.CUOCDIEUTRA_SEARCH_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
